<template>
  <b-modal :title="title" ok-title="Cerrar" class="modal-success" v-model="open" @hidden="clear" ok-only>
      <table>
          <tbody>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>RFC:</strong></th>
                  <td>{{information.Rfc}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Nombre:</strong></th>
                  <td>{{information.Nombre}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Correo:</strong></th>
                  <td>{{information.Correo}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Contacto:</strong></th>
                  <td>{{information.Contacto}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Telefono:</strong></th>
                  <td>{{information.Telefonos}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Vigencia:</strong></th>
                  <td>{{information.Vigencia | Fecha}}</td>
              </tr>
              <tr>
                  <th style="margin-right: 100px; display: block;"><strong>Estatus:</strong></th>
                  <td>
                      <template v-if="information.Estatus === 1"> Activo</template>
                      <template v-else>No Activo</template>
                  </td>
              </tr>
          </tbody>
      </table>
  </b-modal>
</template>
<script>
import moment from 'moment'
import EventBus from '@/event-bus.js'
export default {
  data () {
    return {
      open: false,
      information: {}
    }
  },
  methods: {
    clear () {
      this.information = {}
      this.open = false
    }
  },
  filters: {
    Fecha (fecha) {
      let date = moment(fecha).format('DD-MMM-YYYY')
      let res = date.split('-')
      res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
      return res.join('-')
    },
    Estatus (estatus) {
      return (estatus === 1) ? 'Activo' : 'Desactivado'
    }
  },
  computed: {
    title () {
      return (typeof this.information.Nombre !== 'undefined') ? this.information.Nombre : this.information.RazonSocial
    }
  },
  created () {
    EventBus.$on('openInformation', data => {
      this.information = data
      this.open = true
    })
  }
}
</script>
<style>
span.float-right {
  float: right !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Information.vue